<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.bind')}}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('dictionary.rateset')" :count="params.data.length" :action="$t('bill.bind')" />
      <dialog-table :data="params.data" :columns="params.columns.slice(0,3)" />
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('bill.apply_scope')" prop="type">
          <a-radio-group v-model="form.type">
            <a-radio-button value="domain">{{$t('dictionary.domain')}}</a-radio-button>
            <a-radio-button value="project">{{$t('dictionary.project')}}</a-radio-button>
            <a-radio-button value="organization">{{$t('dictionary.organization')}}</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :label="$t(`dictionary.${form.type}`)" prop="id">
          <base-select
            v-if="form.type === 'domain'"
            v-model="form.id"
            resource="domains"
            filterable
            remote
            :params="domainParams"
            :select-props="{mode: 'multiple', placeholder:$t('common.tips.select', [$t('dictionary.domain')])}" />
          <base-select
            v-if="form.type === 'project'"
            v-model="form.id"
            resource="projects"
            filterable
            remote
            :params="projectParams"
            :select-props="{mode: 'multiple', placeholder:$t('common.tips.select', [$t('dictionary.project')])}" />
          <div v-if="form.type === 'organization'" class="d-flex">
            <organization-select v-model="form.id" :params="orgParams" @change="handleOrgChange" />
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'
import OrganizationSelect from '@/sections/OrganizationSelect'

export default {
  name: 'RatesetBindDialog',
  components: {
    OrganizationSelect,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      form: {
        org_id: undefined,
        id: [],
        type: 'domain',
      },
      rules: {
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      orgNodeOpts: [],
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo']),
    domainParams () {
      return {
        scope: this.scope,
        limit: 20,
      }
    },
    orgParams () {
      const params = {
        scope: this.scope,
      }
      return params
    },
  },
  watch: {
    'form.type': function () {
      this.form.id = []
    },
  },
  created () {
    this.$rM = new this.$Manager('ratesets', 'v1')
  },
  methods: {
    handleOrgChange (orgs) {
      this.form.id = orgs
    },
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        await this.$rM.performAction({
          id: this.params.data[0].id,
          action: 'bind',
          data: this.form.id.map(id => {
            return {
              id,
              type: this.form.type,
            }
          }),
        })
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
